<template>
  <v-menu
    v-bind="$attrs"
    offsetX
    v-on="$listeners"
  >
    <template v-slot:activator="{on}">
      <div
        class="menu-trigger"
        v-on="on"
        @click.stop="$emit('click')"
      >
        <div :class="disableStyleIcon ? '' : 'menu-trigger--icon'">
          <ButtonIcon
            v-if="icon"
            :icon="icon"
            :tooltip="tooltip"
            :loading="loading"
            flat
          />
        </div>
        <v-list-item-title
          v-if="label"
          class="pointer"
        >
          {{ label }}
        </v-list-item-title>
      </div>
    </template>
    <v-toolbar
      v-if="title"
      color="primary"
      dark
      :data-cy="dataCy"
      :elevation="0"
    >
      <v-toolbar-title>
        {{ title }}
      </v-toolbar-title>
    </v-toolbar>
    <!--  Render table in the list item -->
    <div v-if="renderTable">
      <VTableLocal
        class=""
        :items="dropdownLinks"
        :headers="tableHeaders"
        disablePagination
      />
    </div>
    <div v-else>
      <v-list v-if="dropdownOptions && !renderTable">
        <v-list-item
          v-for="(option,idx) in dropdownOptions"
          :key="idx"
          @click="$emit('selected-option', option.option)"
        >
          <v-list-item-title>
            {{ optionsToDisplay(option.name) }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
      <v-list v-if="dropdownLinks">
        <div :class="isCertificationHistory ? 'certificaitonHistory':''">
          <v-list-item
            v-for="(option,idx) in dropdownLinks"
            :key="idx"
            class="borders"
            :class="{'underline': option.id || option.isNew}"
            :disabled="option.isDisabled"
            :href="option.href"
            :to="{ 'name': option.routerPath, 'params': option.params}"
            :target="(option.href) ? '_blank' : '_self'"
            @click="$emit('selected-option', option)"
          >
            <v-list-item-icon v-if="option.certificate">
              <v-icon>mdi-file-pdf-box</v-icon>
            </v-list-item-icon>
            <v-list-item-icon v-if="option.name === 'Add'">
              <v-icon>mdi-plus</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ optionsToDisplay(option.name) }}</v-list-item-title>
          </v-list-item>
        </div>
      </v-list>
    </div>
  </v-menu>
</template>

<script>
import ButtonIcon from '@/components/shared/widgets/ButtonIconTooltip';
import VTableLocal from '@/components/shared/content-views/VTableLocal';

export default {
    components: {
        ButtonIcon,
        VTableLocal,
    },
    props: {
        dropdownOptions: {
            type: Array,
            default: null,
        },
        // A typical object would contain:
        // {
        //  name: element to display,
        //  href: link to go (ie open a pdf),
        //  routerPath: route inside vuerouter,
        // }
        // IMPORTANT: href and routerPath props are mutually exclusive
        dropdownLinks: {
            type: Array,
            default: null,
        },
        label: {
            type: String,
            default: null,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        icon: {
            type: String,
            default: null,
        },
        capitalize: {
            type: Boolean,
            default: false,
        },
        tooltip: {
            type: String,
            default: null,
        },
        title: {
            type: String,
            default: '',
        },
        isCertificationHistory: {
            type: Boolean,
            default: false,
        },
        dataCy: {
            type: String,
            default: '',
        },
        renderTable: {
            type: Boolean,
            default: false,
        },
        tableHeaders: {
            type: Array,
            default: null,
        },
        disableStyleIcon: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        optionsToDisplay(option) {
            return (this.capitalize) ? option.toUpperCase() : option;
        },
    },
};
</script>

<style lang="scss" scoped>

  .menu-trigger {
    display: flex;
    align-items: center;
  }

  .menu-trigger--icon {
    margin-left: -5px;
  }

  .pointer {
    cursor: pointer
  }
  .borders{
    border-bottom: 1px solid #8D969F;
  }
  .underline {
    text-decoration: underline;
  }
  .theme--light.v-list-item--disabled{
    color: rgba(0, 0, 0, 0.38) !important;
  }

</style>
